var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"page-admin-reports-main__table-cell page-admin-reports-main__table-cell-vehicle",class:{
    'page-admin-reports-main__table-cell-vehicle_full': !_vm.singleLetter,
  }},[_vm._v(" "+_vm._s(_vm.vehicleTypeLabel)+" ")])}
var staticRenderFns = []

export { render, staticRenderFns }